import { render } from "./DistributorAddEdit.vue?vue&type=template&id=3f5379ec&scoped=true"
import script from "./DistributorAddEdit.vue?vue&type=script&lang=js"
export * from "./DistributorAddEdit.vue?vue&type=script&lang=js"

import "./DistributorAddEdit.vue?vue&type=style&index=0&id=3f5379ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5379ec"]])

export default __exports__